<template>
  <v-form v-model="form_valido" ref="form" lazy-validation>
    <z-dialogo ref="dialogo" titulo="Enviar Conta / Chave Pix" :dividers="true" altura="500px" :largura="largura"  persistent @fechar="onFechar" no-padding scrollable>

      <template #titlebuttons v-if="tabs == 1">
        <v-btn icon @click="carregarHistorico" :disabled="carregando">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>

      <template #conteudo>

        <v-tabs v-model="tabs" color="primary" background-color="transparent" dense @change="carregarHistorico">
          <v-tab class="text-capitalize" value="whatsapp">Whatsapp</v-tab>
          <v-tab class="text-capitalize" value="historico" :disabled="!whatsapp.fornecedor_nome">Histórico</v-tab>
          <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
        <v-divider></v-divider>
        
        <v-tabs-items v-model="tabs" touchless color="transparent">
          <v-tab-item name="whatsapp" v-bind="$v.TABS_CONFIG">

            <v-row dense>
              <v-col>
                <v-container>
                  <v-row dense >
                    <v-col cols="12">
                      <z-text-field
                        v-model="whatsapp.cliente_nome"
                        label="Cliente Destino"
                        outlined
                        hide-details
                        filled
                        dense
                        append-icon="mdi-magnify"
                        clearable
                        autofocus
                        upper
                        @click:clear="limparDados"
                        @click:append="$refs.dialogoBuscarCliente.abrir(whatsapp.cliente_nome)"
                        @focus="event => event.target.select()"
                        @keypress.enter="event => $refs.dialogoBuscarCliente.abrir(whatsapp.cliente_nome)"
                      ></z-text-field>
                    </v-col>
    
                    <v-col cols="6">
                      <z-telefone
                        v-model="whatsapp.celular"
                        label="WhatsApp Cliente"
                        maxlength="11"
                        return-masked-value
    
                        hide-details
                        filled
                        dense
                        @focus="event => event.target.select()"
                      ></z-telefone>
                    </v-col>
    
                    <v-col cols="6">
                      <z-campo-valor
                        v-model="whatsapp.valor"
                        ref="valor" 
                        label="Valor" 
                        placeholder=" " 
                        filled
    
                        hide-details
                        dense
                      ></z-campo-valor>
                    </v-col>
    
                    <v-col cols="12">
                      <z-text-field
                        v-model="whatsapp.fornecedor_nome"
                        label="Fornecedor"
                        upper
                        filled
                        outlined
                        hide-details
                        dense
                        append-icon="mdi-magnify"
                        clearable
                        @click:clear="limparDados"
                        @click:append="$refs.dialogoBuscarFornecedor.abrir(whatsapp.fornecedor_nome)"
                        @focus="event => event.target.select()"
                        @keypress.enter="event => $refs.dialogoBuscarFornecedor.abrir(whatsapp.fornecedor_nome)"
                      ></z-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="whatsapp.instance_id"
                        label="Enviar usando"
                        filled
                        dense
                        hide-details
                        :items="listasStore.whatsapp_instances"
                        @change="event => $storage.set('instance_id', whatsapp.instance_id)"
                      >
                        <template #item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title v-html="item.text"></v-list-item-title>
                            <v-list-item-subtitle v-html="item.number"></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>

              </v-col>
              <v-col>
                <v-container>
                  <v-card class="pa-0" outlined>
                    <v-tabs v-model="tab" color="primary" background-color="transparent" dense>
                      <v-tab class="text-none" value="contas_chavepix">Contas e ChavesPix</v-tab>
                      <v-tabs-slider color="primary"></v-tabs-slider>
                    </v-tabs>
      
                    <v-divider></v-divider>
      
                    <v-card-text class="pa-0" style="min-height: 370px; height: 370px; overflow-y: auto;">
                      <v-tabs-items v-model="tab" touchless color="transparent">
      
                       
                        <v-tab-item name="contas_chavepix" v-bind="$v.TABS_CONFIG" color="transparent_">
      
                          <v-list subheader dense color="transparent" class="pb-0">
                            <v-list-item-group multiple v-model="contas_chavespix_selecionadas">
                              <v-list-item :value="item" v-for="(item, index) in contasChavesPix" :key="index" color="primary">
                                <template v-slot:default="{ active, }">
                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="active"
                                      color="primary"
                                      readonly
                                    ></v-checkbox>
                                  </v-list-item-action>
          
                                  <v-list-item-content v-if="item.tipo == 'conta'">
                                    <v-list-item-title>{{ item.banco.descricao }}</v-list-item-title>
                                    <v-list-item-subtitle>Conta: {{ item.numero_conta }} Agência: {{ item.agencia }}</v-list-item-subtitle>
                                  </v-list-item-content>

                                  <v-list-item-content v-if="item.tipo == 'chave_pix'">
                                    <v-list-item-title>Pix: {{ item.chave }}</v-list-item-title>
                                    <v-list-item-subtitle>Tipo: {{ item.tipo }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>Titular: {{ item.titular }}</v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
      
                        </v-tab-item>
                      </v-tabs-items>
      
                    </v-card-text>
                  </v-card>
                </v-container>

              </v-col>
            </v-row>



          </v-tab-item>

          <v-tab-item name="historico" v-bind="$v.TABS_CONFIG">
            <CompartilharContasHistorico></CompartilharContasHistorico>
          </v-tab-item>
        </v-tabs-items>



      </template>

      <template #actions_left v-if="tabs == 1">
        <h4>Fornecedor: {{ whatsapp.fornecedor_nome }}</h4>
      </template>
      <template #actions_right>
        <v-btn depressed color="primary" @click="tabs = 0" v-show="tabs == 1">
          <v-icon left>{{$icon.VOLTAR}}</v-icon>
          Voltar
        </v-btn>
        <v-btn text @click="$refs.dialogo.fechar()" :disabled="enviando" v-show="tabs == 0">
          Cancelar
        </v-btn>
        <v-btn depressed color="primary" @click="enviar" :disabled="!podeEnviar" :loading="enviando" v-show="tabs == 0">
          Enviar
        </v-btn>
      </template>
    </z-dialogo>


    <DialogoBuscarCliente ref="dialogoBuscarCliente" @selecionar="selecionarCliente"></DialogoBuscarCliente>
    <DialogoBuscarFornecedor ref="dialogoBuscarFornecedor" @selecionar:fornecedor="selecionarFornecedor"></DialogoBuscarFornecedor>


  </v-form>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, inject } from 'vue';
import DialogoBuscarCliente from '@/components/buscas/DialogoBuscarCliente.vue';
import DialogoBuscarFornecedor from '@/components/buscas/DialogoBuscarFornecedor.vue';
import CompartilharContasHistorico from '@/pages/contaspagar/CompartilharContaHistorico.vue';
import queryBuilder from '@/app/helpers/QueryBuilder';
import { useListasStore } from '@/app/store/pinia/listas.js';
import { usePagamentosStore } from '@/app/store/pinia/pagamentos';
import axios from "@/app/plugins/Axios";
import config from '@/app/config';
import fornecedoresApi from "@/app/services/fornecedores";

const listasStore = useListasStore();
const pagamentosStore = usePagamentosStore();

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $globals = proxy.$globals;
const $storage = proxy.$storage;
const $notificacao = inject('notificacao');

const tab = ref(0);
const tabs = ref(0);
const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const enviando = ref(false);
const carregando = ref(false);

const cliente_id = ref(null)
const cliente = ref(null)
const chavepix = ref(null);
const conta = ref(null);
const pagamento = ref(null);
const celular = ref(null);
const nome = ref(null);
const contasChavesPix = ref([]);
const contas_chavespix_selecionadas = ref([]);

const whatsapp = ref({
  instance_id: null,
  cliente_nome: null,
  cliente: null,
  celular: null,
  fornecedor: null,
  fornecedor_nome: null,
  conta_id: null,
  chavepix_id: null,
  valor: 0, 
}); 

const podeEnviar = computed(() => {
  return whatsapp.value.cliente_nome != null && 
         whatsapp.value.celular != null && 
         whatsapp.value.fornecedor != null && 
         contas_chavespix_selecionadas.value.length > 0;
});

const largura = computed(() => {
  return tabs.value === 1 ? '900px' : '900px';
});

async function abrir(item) {
  pagamento.value = item;
  tabs.value = 0;

  if (whatsapp.value.fornecedor) {
    await carregarDadosPix();
  } else {
    limparDados();
  }

  if (!listasStore.whatsapp_instances || listasStore.whatsapp_instances.length === 0) {
    await carregarCelulares();
  }

  if ($storage.has('instance_id')) {
    whatsapp.value.instance_id = $storage.get('instance_id');
  }
  dialogo.value.abrir();
}

function fechar() {
  onFechar();
  dialogo.value.fechar();
}

function onFechar() {
  form.value.resetValidation();
}

async function enviar() {

  try {
    enviando.value = true;
    // axios.defaults.baseURL = config.BASE_URL;

    let contas_chavespix_ids = contas_chavespix_selecionadas.value.map(item => {
      return {
        tipo: item.tipo,
        id: item.id
      }
    });

    const response = await axios.post('/contaspagar/whatsapp/enviarconta', {
      instance_id: whatsapp.value.instance_id,
      cliente_id: !whatsapp.value.cliente ? null : whatsapp.value.cliente.id,
      cliente_nome: whatsapp.value.cliente_nome,
      fornecedor_id: whatsapp.value.fornecedor.id,
      // tipo_pix: chavepix.value.tipo,
      valor: whatsapp.value.valor,
      celular: whatsapp.value.celular.replace(/\D/g, ''),
      // chavepix_id: tab.value == 0 && chavepix.value ? chavepix.value.id : null,
      // conta_id: tab.value == 1 && conta.value ? conta.value.id : null,
      contas_chavespix_ids: contas_chavespix_ids,
    });


    tabs.value = 1;
    await carregarHistorico();
    $notificacao.notificar("Chave Pix salva com sucesso!");
  } catch (error) {
    $notificacao.error("Houve um erro ao salvar a Chave Pix", error);
    throw error;
  } finally {
    axios.defaults.baseURL = config.API_URL;
    enviando.value = false;
    // dialogo.value.fechar();

    setTimeout(() => {
      carregarHistorico();
    }, 3000);
  }
}

function selecionarCliente(cliente) {
  whatsapp.value.cliente = cliente;
  whatsapp.value.cliente_nome = cliente.razao;
  whatsapp.value.celular = cliente.celular.replace(/\D/g, '');
}

function selecionarFornecedor(fornecedor) {
  whatsapp.value.fornecedor = fornecedor;
  whatsapp.value.fornecedor_nome = fornecedor.razao;
  carregarContasChaves();
  carregarDadosPix();
}

function limparDados() {
  whatsapp.value.instance_id = null;
  whatsapp.value.cliente = null;
  whatsapp.value.cliente_nome = null;
  whatsapp.value.celular = null;
  whatsapp.value.fornecedor = null;
  whatsapp.value.fornecedor_nome = null;
  whatsapp.value.fornecedor_celular = null;
  listasStore.chaves_pix = [];
  listasStore.contas_bancarias = [];
  chavepix.value = null;
  conta.value = null;
}

async function carregarDadosPix() {

  try {
    carregando.value = true;

    if (whatsapp.value.fornecedor == null) {
      return;
    }

    await listasStore.fetchListas([
      queryBuilder()
        .model("ChavePix")
        .where(`fornecedor_id=${whatsapp.value.fornecedor.id}`)
        .orderBy("tipo")
        .build(),
      queryBuilder()
        .model("ContaBancaria")
        .where(`fornecedor_id=${whatsapp.value.fornecedor.id}`)
        .with('banco:id,codigo,descricao')
        // .orderBy("tipo")
        .build(),
      queryBuilder()
        .select('id','datahora', 'celular', 'valor', 'chavepix_id', 'conta_id', 'cliente_nome', 'cliente_id', 'fornecedor_id', 'status_envio', 'mensagem', 'key_id')
        .model('RegistroWhatsapp')
        .where(`fornecedor_id=${whatsapp.value.fornecedor.id}`)
        .orderBy('-datahora')
        .build()
    ]);
  } catch (error) {
    $notificacao.error("Houve um erro ao carregar os dados", error);
    throw error;
  } finally {
    carregando.value = false;
  }
}


async function carregarHistorico() {
  try {
    carregando.value = true;

    if (whatsapp.value.fornecedor == null) {
      return;
    }

    await listasStore.fetchListas([
      queryBuilder()
        .select('id','datahora', 'celular', 'valor', 'chavepix_id', 'conta_id', 'cliente_nome', 'cliente_id', 'fornecedor_id', 'status_envio', 'mensagem', 'key_id')
        .model('RegistroWhatsapp')
        .where(`fornecedor_id=${whatsapp.value.fornecedor.id}`)
        .orderBy('-datahora')
        .build()
    ]);
  } catch (error) {
    $notificacao.error("Houve um erro ao carregar os dados", error);
    throw error;
  } finally {
    carregando.value = false;
  }
}

async function carregarContasChaves() {
  if (whatsapp.value.fornecedor == null) {
    return;
  }

  try {
    carregando.value = true;

    const response = await fornecedoresApi.listarContasChaves(whatsapp.value.fornecedor.id);
    contasChavesPix.value = response.contas_chavespix;
  } catch (error) {
    $notificacao.error("Houve um erro ao carregar as Contas e Chaves Pix", error);
    throw error;
  } finally {
    carregando.value = false;
  }
}

async function carregarCelulares() {
  await listasStore.fetchListas([
    queryBuilder()
      .select('id as value','instance_name as text', 'number')
      .model('WhatsappInstance')
      .build()
  ]);
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>